import { useId } from 'react';

export function useInternalId(idProp?: string) {
  const _id = useId();
  return idProp ?? _id;
}
